import script from "./update.vue?vue&type=script&lang=ts&setup=true"
export * from "./update.vue?vue&type=script&lang=ts&setup=true"

import "./update.vue?vue&type=style&index=0&id=1324ecee&lang=scss&scoped=true"

import exportComponent from "/opt/data/jenkins/workspace/auto-build-release-node-server-new-2024/TMP/PROD/ashe/ashe-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1324ecee"]])

export default __exports__